const subDomain = process.env.REACT_APP_COMMAN_SUB_DOMAIN;

const getEnvironmentPart = (domain) => {
  const fullDomain = domain || document.domain;
  const regexPattern = new RegExp(`${subDomain}-([^.]+)\\.`);
  const match = fullDomain.match(regexPattern);
  return match ? match[1] : "";
};

const ENVIRONMENT_MAPPINGS = process.env.REACT_APP_ENV_MAPPING
  ? JSON.parse(process.env.REACT_APP_ENV_MAPPING)
  : {};

const getMappedEnvironmentName = (domain) => {
  const environmentPart = getEnvironmentPart() || domain;
  return ENVIRONMENT_MAPPINGS[environmentPart] || "Unknown";
};

const getSelectedTenant = () => {
  const url =
    '{"tenantId":"ede8d4b1-6713-4e3b-b75c-e0236a8fcc13","tenantName":"ZCS DSSO","tenantActive":true,"userActive":true,"tenantDSSOUrl":"dsso-rp.zycus.com","tenantIsDSSO":false,"userLoginThroughPortal":true,"multiZauthConfig":[{"idp":"zcs","domainURL":"dsso-rp.zycus.com"},{"idp":"autotestingnew","domainURL":"test.zycusinfo.com"}]}';
  return url;
};
const getSelectedSetupUrl = (domain) => {
  const url = `https://dewdrops-${domain}.zycus.com/home/api/ca/`;
  return url;
};

const createAddobjectId = () => {
  const crypto = window.crypto || window.msCrypto; // for IE 11

  const template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return template.replace(/[xy]/g, (char) => {
    const r =
      (crypto.getRandomValues(new Uint8Array(1))[0] & 0x0f) >>
      (char === "x" ? 0 : 1);
    return (char === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export {
  getEnvironmentPart,
  getMappedEnvironmentName,
  getSelectedSetupUrl,
  createAddobjectId,
  getSelectedTenant,
};
